module.exports = __webpack_public_path__ + "assets/img/binding-1-sm.42012732.jpg";